import { render, staticRenderFns } from "./idf.20211004.default.vue?vue&type=template&id=6be524c8&slot=start-instructions&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports